import { render, staticRenderFns } from "./editdealer.vue?vue&type=template&id=099589ee&scoped=true&"
import script from "./editdealer.vue?vue&type=script&lang=js&"
export * from "./editdealer.vue?vue&type=script&lang=js&"
import style0 from "./editdealer.vue?vue&type=style&index=0&id=099589ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099589ee",
  null
  
)

export default component.exports